import React, { useEffect, useState } from 'react'
import LoginCookieAuth from '../api/LoginCookieAuth';
import SkySparkGrid from '../api/SkySparkGrid';
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Box } from '@mui/system';
import { LinearProgress, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import InfLoader from '../infLoad';
import DataUnavailable from '../data/DataUnavailable';

// If value = '-' return 0 as value for sorting
const customComparator = (v1, v2) => {
    if (v1 === '-' && v2 === '-') {
        return 0;
    }
    if (v1 === '-') {
        return -1;
    }
    if (v2 === '-') {
        return 1;
    }
    return v1 - v2;
};

// Collumns for table
const columns = [
    { field: 'kamer', headerName: 'Ruimte', width: 230, headerClassName: 'collumnHeader' },
    {
        field: 'temperatuur', headerName: 'Ruimtetemperatuur', width: 150, headerClassName: 'collumnHeader', type: 'number', renderCell: (params) => (
            <>
                {
                    params.value !== '-' ? (
                        <>{params.value}°C</>
                    ) : (
                        <>{params.value}</>
                    )
                }
            </>
        ), sortComparator: customComparator,
    },
    {
        field: 'setpoint', headerName: 'Gewenste ruimtetemperatuur', width: 230, headerClassName: 'collumnHeader', type: 'number', renderCell: (params) => (
            <>
                {
                    params.value !== '-' ? (
                        <>{params.value}°C</>
                    ) : (
                        <>{params.value}</>
                    )
                }
            </>
        ), sortComparator: customComparator,
    },
    {
        field: 'co2', headerName: 'Luchtkwaliteit (CO2)', width: 180, headerClassName: 'collumnHeader', type: 'number', renderCell: (params) => (
            <>
             {
                params.value !== '-' ? (
                    <>{params.value}ppm</>
                ) : (
                 <>{params.value}</>
                )
            }
            </>
        )
    },
    {
        field: 'vochtigheid', headerName: 'Luchtvochtigheid', width: 180, headerClassName: 'collumnHeader', type: 'number', renderCell: (params) => (
            <>
                {
                    params.value !== '-' ? (
                        <>{params.value}%</>
                    ) : (
                        <>{params.value}</>
                    )
                }
            </>
        ), sortComparator: customComparator,
    },
]

const TableView = ({ showSearch, size, color }) => {
    const { siteId } = useParams();
    const [tabelData, SetTabelData] = useState([])
    const [searchText, setSearchText] = useState('')
    const [loading, setLoading] = useState(true)
    const [tableLoading, setTableLoading] = useState(true)

    // Fetch and set table data
    useEffect(() => {
        if(!loading) setLoading(true)
        const fetchData = async () => {
            if (!tableLoading) setTableLoading(true)
            LoginCookieAuth(Cookies.get('skyarc-auth-8080')).then(async(response) => {
                if(response) {
                    SkySparkGrid(`api_siteSensors(@${siteId})`).then((response) => {
                        if(response['data']['rows'] !== null && response['data']['rows'].length !== 0)
                        SetTabelData(response['data']['rows'])
                        setLoading(false)
                        setTableLoading(false)
                    })
                }
            })
        };
        // Initial fetch
        fetchData();

        // Set up interval to fetch data every 10 seconds
        const intervalId = setInterval(fetchData, 10000);

        // Cleanup the interval when the component is unmounted
        return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteId]);

    const CheckNum = (value) => {
        if (isNaN(value)) {
            return '-'
        } else {
            return Math.round(value)
        }
    }

    const CheckTemp = (value) => {
        if (isNaN(value)) {
            return '-'
        } else {
            return (Math.round(value * 10) / 10)
        }
    }

    // Build list of objects with tabeldata 
    const tableDataRows = tabelData
    .filter(room => room.navName !== 'Active Power') // Filter out the room with name 'Active Power'
    .map((room, index) => {
        let humidityName = "-";
        if (room.points['rows'].find((row) => row["humidity"] != null) != null && room.points['rows'].find((row) => row["humidity"] != null)["curVal"] != null) humidityName = room.points['rows'].find((row) => row["humidity"] != null).curVal.val
        let tempName = "-"
        if (room.points['rows'].find((row) => row["temp"] != null && row["discharge"] == null && row["sp"] == null && row["average"] == null) != null && room.points['rows'].find((row) => row["temp"] != null && row["discharge"] == null && row["sp"] == null && row["average"] == null)["curVal"] != null) {
            tempName = room.points['rows'].find((row) => row["temp"] != null && row["discharge"] == null && row["sp"] == null && row["average"] == null).curVal.val;
        }
        let co2Name = "-"
        if (room.points['rows'].find((row) => row["co2"] != null) != null && room.points['rows'].find((row) => row["co2"] != null)["curVal"] != null) co2Name = room.points['rows'].find((row) => row["co2"] != null).curVal.val
        let setPointName = '-'
        if (room.points['rows'].find((row) => row["temp"] != null && row["discharge"] == null && row["sp"] != null && room.points['rows'].find((row) => row["temp"] != null && row["discharge"] == null && row["sp"] != null && row["average"] == null)["curVal"] != null)) {
            setPointName = room.points['rows'].find((row) => row["temp"] != null && row["discharge"] == null && row["sp"] != null && row["average"] == null).curVal.val;
        }
        return {
            id: index + 1,
            kamer: room.navName,
            vochtigheid: CheckNum(humidityName),
            temperatuur: CheckTemp(tempName),
            setpoint: setPointName,
            co2: co2Name
        };
    }); 

  return (
    // Parrent container
    <Box>
        {
            loading ? (
                <Box sx={{width:'100%', height: size === undefined ? ('900px') : (`${size}px`), display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <InfLoader/>
                </Box>
            ) : (
                tabelData.length !== 0 ? (
                    <Box>
                        {
                            showSearch ? (
                            <Box mb={2} sx={{width:'100%'}}>
                                <TextField
                                    label={searchText ? " " : "Zoeken"}
                                    fullWidth
                                    variant="outlined"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    InputLabelProps={{shrink: false, sx: { mt: '-10px' }}}
                                    InputProps={{ sx: { height: '30px' } }}
                                />
                            </Box>
                            ) : (
                                <></>
                            )
                        }
                        <Box sx={{
                            // temp colors
                            '& .bad': {
                                fontWeight: 'bold',
                                fontSize: '14px',
                                color: '#cf3c3c',
                            },
                            '& .average': {
                                fontWeight: 'bold',
                                fontSize: '14px',
                                color: '#FF5F15',
                            },
                            '& .good': {
                                fontWeight: 'bold',
                                fontSize: '14px',
                                color: '#57d147',
                            },
                            '& .collumnHeader': {
                                fontSize: '14px',
                                fontWeight: 'bold !important',
                            },
                            '& .kamerHeadStyle': {
                                fontSize: '14px',
                            },
                            '.MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold !important',
                            },
                            '.MuiLinearProgress-bar': {
                                backgroundColor: '#00E886',
                            },
                            '& .noData': {
                                color: 'black',
                            },
                            '& .setPoint': {
                                fontSize: '14px',
                                fontWeight: 'bold'
                            },
                            '.MuiDataGrid-noResults': {
                                display: 'none !imporant'
                            }
                        }}>
                            <DataGrid
                            sx={{marginTop:'18px', backgroundColor:color, fontWeight:'bold', "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {outline: "none !important"}, "&.MuiDataGrid-root .MuiDataGrid-columnHeader": {outline:'none'}, height:`${size}px`}}
                            disableColumnMenu
                            rows={tableDataRows}
                            columns={columns}
                            disableSelectionOnClick
                            disableSelection
                            loading={tableLoading}
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'kamer', sort: 'asc' }],
                                },
                            }}
                            slots={{
                                loadingOverlay: LinearProgress,
                                // Hide no results text
                                noResultsOverlay: () => (<div style={{display:'none'}}> No results found </div> )
                            }}
                            filterModel={{
                                items: [
                                    {
                                        field: 'kamer',
                                        operator: 'contains',
                                        value: searchText,
                                    },
                                ],
                            }}
                            getCellClassName={(params) => {
                                if (params.field === 'temperatuur') {
                                    let temprature = parseFloat(params.value)
                                    let setPoint = (params.row.setpoint)
                                    // If row has setpoint
                                    if (setPoint !== '-') {
                                        const temperatureDifference = Math.abs(temprature - setPoint);
                                        if (temperatureDifference <= 1) return 'good'
                                        else if (temperatureDifference <= 2 && temperatureDifference > 1) return 'average'
                                        else if (temperatureDifference >= 2) return 'bad'
                                    } else {
                                        const temperatureDifference = Math.abs(temprature - 21);
                                        if (temperatureDifference <= 1) return 'good'
                                        else if (temperatureDifference <= 2 && temperatureDifference > 1) return 'average'
                                        else if (temperatureDifference >= 2) return 'bad'
                                    }
                                } else if (params.field === 'co2') {
                                    let co2Ppm = parseFloat(params.value)
                                    if (co2Ppm >= 0 && co2Ppm <= 651) {
                                        return 'good'
                                    } else if (co2Ppm >= 651 && co2Ppm <= 1050) {
                                        return 'average'
                                    } else if (co2Ppm >= 1051) {
                                        return 'bad'
                                    } else {
                                        return 'noData'
                                    }
                                } else if (params.field === 'vochtigheid') {
                                    let humidity = parseFloat(params.value)
                                    if (humidity >= 0 && humidity <= 20) {
                                        return 'bad'
                                    } else if (humidity >= 20 && humidity <= 35) {
                                        return 'average'
                                    } else if (humidity >= 35 && humidity <= 65) {
                                        return 'good'
                                    } else if (humidity >= 65 && humidity <= 80) {
                                        return 'average'
                                    } else {
                                        return 'noData'
                                    }
                                } else if (params.field === 'setpoint') {
                                    return 'setPoint'
                                } else if (params.field === 'kamer') {
                                    return 'kamerHeadStyle'
                                }
                            }}
                            />
                        </Box>
                    </Box>
                ) : (
                    <Box sx={{width:'100%', height:'250px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <DataUnavailable message="Geen ruimte data beschikbaar"/>
                    </Box>
                )
            )
        }
    </Box>
  )
}

export default TableView
